var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"alumni"}},[_c('lead'),_c('main',{staticClass:"main"},[_c('keep-alive',{attrs:{"include":"news"}},[_c('router-view',{key:this.$route.query.id})],1)],1),_c('foote')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }